import React from 'react';
import Loader from './Loader';

const InfiniteLoader = React.forwardRef((_props, ref) => <Loader ref={ref} text="Loading more accommodations" />);

export default InfiniteLoader;
